import React, {useContext} from 'react';

import {AppContext} from '../../../../AppModule/Context';

import LeadCollectorComponent from '../../../widgetComponent/openWidgetComponent/leadCollectorComponent';

import VIDABOO_CONSTANTS from '../../../../config/consts';

import './schedulingInWidgetStep2.css';

const SchedulingInWidgetStep2 = (props) => {
  const context = useContext(AppContext);
  return (
    <div className="et-sr-step2">
      <LeadCollectorComponent
        isDemo={props.isDemo}
        requesterEmail={props.requesterEmail}
        callSendMessageFunc={props.callSendMessageFunc}
        mentor={props.mentor}
        selectedWidgetAppType={
          VIDABOO_CONSTANTS.WIDGET_APP_TYPES.SCHEDULE_MEETING
        }
        callbackSuccessInfoSend={props.submitBookingFlow}
        isBookingFlowRunning={props.isBookingFlowRunning}
        submitBtnTxt={
          props.isAutoApprovalEnabled
            ? context.languageSet.CONSOLTO_WIDGET.SCHEDULE_A_MEETING
            : context.languageSet.SCHEDULING.SEND_INVITATION
        }
        backBtnFunc={() => {
          props.moveSchedulingStep(0, true);
        }}
        getRecipientsListWithAddButtonComp={
          props.getRecipientsListWithAddButtonComp
        }
        areAllEmailsValid={props.areAllEmailsValid}
        paymentFlowBasedSessionDto={props.paymentFlowBasedSessionDto}
      />
    </div>
  );
};

export default SchedulingInWidgetStep2;
